import React, { Component, PureComponent } from 'react'
import {ReactComponent as Group} from '../assets/icons/Group.svg'
import {ReactComponent as RightIcon} from '../assets/icons/rightArrow.svg'
 import {ReactComponent as DownIcon} from '../assets/icons/downArrow.svg'
 import {ReactComponent as LockIcon} from '../assets/icons/lock.svg'
 import {ReactComponent as Options} from '../assets/icons/options.svg'
 import {ReactComponent as UnLockIcon} from '../assets/icons/Unlock.svg'
 import { exportDrawing,previewDrawing,saveDrawing,textSelected,selectedObject} from "./../actions/wizard";

import './AnnotationGroup.scss'
import {connect} from 'react-redux';
import AnnotationLayer from './AnnotationLayer'
import AnnotationObj from './AnnotationObj'
class AnnotationGroup extends Component<any,any> {
    private optionsRef: React.RefObject<HTMLDivElement>;
    private grpRef : React.RefObject<HTMLDivElement>;
    constructor(props) {
      super(props)
      this.optionsRef = React.createRef<HTMLDivElement>();
      this.grpRef = React.createRef<HTMLDivElement>();
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.state = {
         open:false,
         showOptions:false
      }
    }

    handleClickOutside(event) {
        if (this?.optionsRef?.current && !this.optionsRef?.current?.contains(event.target)) {
            this.setState({showOptions:false})
        }
      };
    
      componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    

   
  handleGroupSelected = (e) => {
    this.setState({open:!this.state.open});
    if(this.props.groupType == 'created'){
        console.log("highlightActiveObject");
        this.props.fabricInstance.setActiveObject(this.props.grp);
        this.props.fabricInstance.renderAll()
    }
    this.props.selectedObject([]);
  } 

  
handleLock = ()  => {
    this.props.grp.set({
          selectable:false,
          editable:false,
          evented:false,
          hasControls:false,
          lockMovementX:true,
          lockMovementY:true
      });  
      
    this.props.fabricInstance.renderAll();
}


handleIncreaseGrpZindex = () => {
    this.props.grp.bringToFront();   
    this.props.grp.set("dirty", true);
    this.setState({showOptions:false})
    this.props.fabricInstance.renderAll();
    this.props.saveDrawing();
  }

handleDecreaseGrpZindex = () => {
    this.props.grp.sendToBack();
    this.props.grp.set("dirty", true);
    this.setState({showOptions:false})
    this.props.fabricInstance.renderAll();
    this.props.saveDrawing();

  }

handleUnlock =  () => {
    this.props.grp.set({
        selectable:true,
        hasControls:true,
        editable:true,
        evented:true,
        lockMovementX:false,
        lockMovementY:false
    });
    this.props.fabricInstance.renderAll();
}

// Function to un-hide the element
unHideElement = () => {
    this.props.grp.set('visible', true);
    this.props.fabricInstance.renderAll();
    this.props.saveDrawing();
}

  render() {
    let ElipseObjects=[],RectangleObjects=[],TextObjects=[],LineObjects=[],ImageObjects=[],TriangleObjects=[], PathObj=[];
    const {grp,grpIndex,groupType} = this.props;

    if(!groupType.includes('default')){

        grp?._objects.map(obj => {
            if(obj.type.includes('ellipse')){
                ElipseObjects.push(obj);
            }
            if(obj.type.includes('rect')){
                RectangleObjects.push(obj);
            }
            if(obj.type.includes('text')){
                TextObjects.push(obj);
            }
            if(obj.type.includes('line')){
                LineObjects.push(obj);
            }
            if(obj.type.includes('image')){
                ImageObjects.push(obj);
            }
            if(obj.type.includes('triangle')){
                TriangleObjects.push(obj)
            }
            if(obj.type.includes('path')){
                PathObj.push(obj)
            }
            if (obj.type == 'group') {
                obj?._objects.map(obj1 => {
                    
                    if (obj1.type.includes('ellipse')) {
                        ElipseObjects.push(obj1);
                    }
                    if (obj1.type.includes('rect')) {
                        RectangleObjects.push(obj1);
                    }
                    if (obj1.type.includes('text')) {
                        TextObjects.push(obj1);
                    }
                    if (obj1.type.includes('line')) {
                        LineObjects.push(obj1);
                    }
                    if (obj1.type.includes('image')) {
                        ImageObjects.push(obj1);
                    }
                    if(obj1.type.includes('triangle')){
                        TriangleObjects.push(obj1)
                    }
                    if(obj1.type.includes('path')){
                        PathObj.push(obj1)
                    }
                })
            }
        })
    }
    return (
        <div className='annotation-grp' >
            <div  ref={this.grpRef} className='grp-header'>
                <div   style={{display:'flex',padding:'8px',flexDirection:'row'}} onClick={(e) => this.handleGroupSelected(e)}>
                    <div style={{padding:'3px'}}>{!this.state.open ? <RightIcon></RightIcon> : <DownIcon></DownIcon>}</div>
                    {groupType=='created' && <div style={{padding:'4px'}}>{ `Group ${this.props.grpIndex+1}`}</div>}
                    {groupType=='default' && <div style={{padding:'4px'}}>{ `Default Group`}</div>}
                </div>
                {
                         groupType=='created' && <div style={{display:'flex',flexDirection:'row'}}>
                         <div style={{padding:'12px'}} >
                            { grp && !grp.hasControls ? <LockIcon onClick={this.handleUnlock}/> : <UnLockIcon onClick={this.handleLock}/>}
                        </div>
                        <div style={{padding:'8px'}}  onClick={() => this.setState({showOptions:!this.state.showOptions})}>
                            <Options></Options>
                        </div>
                        {
                           this.state.showOptions && <div className='layering-container'>
            
                                { 
                                    <div className="layering-dropdown" ref={this.optionsRef} >
                                        <ul className="layer-opts">
                                        <li onClick={this.handleIncreaseGrpZindex}>Bring to front</li>
                                        <li onClick={this.handleDecreaseGrpZindex}>Set to Back</li>
                                        <hr />
                                        <li onClick={this.unHideElement}>UnHide</li>
                                        <li onClick={this.handleUnlock}>Unlock</li>
                                        </ul>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    }
            </div>
            {
               this.state.open &&  <div className={'grp-layer'} style={{display:'flex',flexDirection:'column',padding:'0px 8px 8px 8px'}}>
                
                { ElipseObjects.length>0 && <AnnotationLayer key={`Ellipse${grpIndex}`} grp= {grp} layerName={'Ellipse'} layerObjects={ElipseObjects}></AnnotationLayer>}
                { RectangleObjects.length>0 && <AnnotationLayer key={`Rectangle${grpIndex}`} grp= {grp} layerName={'Rectangle'} layerObjects={RectangleObjects}></AnnotationLayer>}
                {
                 TextObjects.length>0 && <AnnotationLayer key={`Text${grpIndex}`} grp= {grp} layerName={'Text'} layerObjects={TextObjects}></AnnotationLayer>
                }
                {
                 LineObjects.length>0 && <AnnotationLayer key={`Line${grpIndex}`}  grp= {grp} layerName={'Line'} layerObjects={LineObjects}></AnnotationLayer>
                }
                {
                 ImageObjects.length>0 && <AnnotationLayer  key={`Image${grpIndex}`} grp= {grp} layerName={'Image'} layerObjects={ImageObjects}></AnnotationLayer>
                }
                {
                 TriangleObjects.length>0 && <AnnotationLayer  key={`Image${grpIndex}`} grp= {grp} layerName={'Triangle'} layerObjects={TriangleObjects}></AnnotationLayer>
                }
                {
                 PathObj.length>0 && <AnnotationLayer  key={`Image${grpIndex}`} grp= {grp} layerName={'Path'} layerObjects={PathObj}></AnnotationLayer>
                }
            </div>
        }
        {
            groupType=='default' && this.state.open && grp.map( (obj,i) => {
                return <AnnotationObj groupType={groupType} index={i} layerName={obj.type} obj={obj} grp={grp}></AnnotationObj>
            })

        }
        </div>
    )
  }
}

export default connect(
    (state: any) => ({
        fabricInstance:state.wizard.fabricInstance,
        selectedObjects:state.wizard.selectedObjects
    }),
    {
        saveDrawing,
        selectedObject
    }
)(AnnotationGroup)